import { fromEmpty } from 'maybeasy';
import { Building, modifiableExperiences } from '.';
import { ExperienceResource } from '../../../../Types';
import LearningDesignExperienceStore from '../../../Experience/Store';
import { experienceStore } from '../../../Experience/Types';
import { ModifiableExperiences, SectionContext } from '../../../Types';

const filterDeletedExperienceStores = (
  context: SectionContext,
  state: Building,
  experienceResource: ExperienceResource,
): LearningDesignExperienceStore[] =>
  modifiableExperiences(context, state).deletedExperienceStores.filter((store) =>
    store.represents(experienceResource),
  );

const buildExperienceStoresFromResource =
  (context: SectionContext, state: Building) =>
  (experienceResource: ExperienceResource): LearningDesignExperienceStore[] =>
    fromEmpty(filterDeletedExperienceStores(context, state, experienceResource)).getOrElse(() => [
      experienceStore(experienceResource),
    ]);

const alreadyAddedExperienceIds = (
  context: SectionContext,
  state: Building,
): ReadonlyArray<number> =>
  modifiableExperiences(context, state).experienceStores.map(
    (store) => store.experienceResource.payload.id,
  );

const filteredExperienceResources = (
  context: SectionContext,
  experienceResources: ExperienceResource[],
  state: Building,
): ExperienceResource[] =>
  experienceResources.filter(
    (resource) => !alreadyAddedExperienceIds(context, state).includes(resource.payload.id),
  );

export const addExperienceStores = (
  context: SectionContext,
  state: Building,
  experienceResources: ExperienceResource[],
): ModifiableExperiences => {
  const filtered = filteredExperienceResources(context, experienceResources, state);
  const experienceStores = filtered.flatMap(buildExperienceStoresFromResource(context, state));

  const deletedExperienceStores = modifiableExperiences(
    context,
    state,
  ).deletedExperienceStores.filter((deletedExperienceStore) =>
    deletedExperienceStore.representsAny(filtered),
  );

  return {
    deletedExperienceStores,
    experienceStores: experienceStores.concat(
      modifiableExperiences(context, state).experienceStores,
    ),
  };
};
